import { render, staticRenderFns } from "./open-close-selector.vue?vue&type=template&id=84a8e654&"
import script from "./open-close-selector.vue?vue&type=script&lang=js&"
export * from "./open-close-selector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports